import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'

export class StyleTwoRaiders extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    stageData: [
      { id: 1, title: '阶段一', mg: '161px' },
      { id: 2, title: '阶段二', mg: '333px' },
      { id: 3, title: '阶段三', mg: '338px' }
    ]
  }

  render() {
    let { itemsData, onMeiQiaCustomer } = this.props;
    let { stageData } = this.state;
    return (
      <div className="style-two-style-two-raiders">
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <div className='stage_box'>
          <div className='stage_title_box flex_row'>
            {stageData && stageData.map(item => <div className='stage_title_item' style={{ marginLeft: `${item.mg}` }} key={item.id}>{item.title}</div>)}
          </div>
          <img src={itemsData.stageImg} alt="" />
          <div className='raiders_list flex_row'>
            {itemsData.list && itemsData.list.map(item => <div className={item.list.length > 1 ? 'raiders_item big_item' : 'raiders_item'} key={item.id}>
              {item.list && item.list.map(_item => <div className='raiders_i_item' style={{ borderBottom: `${item.list.length > 1 && _item.id === 1 ? 'dashed 1px #dca551': 'none'}`}} key={_item.id}>
                <div className='i_item_title flex_row' style={{ width: `${_item.width}`, background: `url(${_item.titleBack})` }}>{_item.title}</div>
                {_item.contentList && _item.contentList.map(_i => <div className='raiders_content' key={_i.id}>{_i.content}</div>)}
              </div>)}
              <div className='go_study_btn flex_row' onClick={onMeiQiaCustomer}>开始学习</div>
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoRaiders);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoRaiders.js